import type { Namespace } from './types';
export const zh: Namespace = {
  events: {
    notify: {
      /** 浮层正文的行标签——**具体的事实**，各自带自己的标签。 */
      factOrder: '订单号：{{order}}',
      factCode: '代码：{{code}}',
    },
  },
};
export const en: Namespace = {
  events: {
    notify: {
      factOrder: 'Order No.: {{order}}',
      factCode: 'Code: {{code}}',
    },
  },
};
